export default {
  product: {
    shareButton: 'Share',
    seeAllImages: 'See all images',
    eventsFromTheSameSupplier: 'Workshops from the same partner',
    similarEvents: 'Similar classes',
    similarCourseEvents: 'Discover similar classes near you',
    similarTourEvents: 'Discover similar tours near you',
    similarExperienceEvents: 'Discover similar experiences near you',
    similarOnlineEvents: 'Similar virtual classes',

    boxEventLabel: 'Kits',
    boxSimilarLabel: 'Discover similar kits',
    boxSimilarLabelOnEventPage: 'Discover our DIY kits',
    giftcardEventsFromTheSameSupplier: 'Discover other gift cards',
    giftcardSimilarEvents: 'Popular classes for this gift card',
    giftcardSimilarOnlineEvents: 'Popular online classes for this gift card',

    promo: {
      giftcard: 'Gift time; {eventCount} experiences; Gift boxes',
      teamevent: 'Team events; Private groups; Company parties',
    },

    sale: {
      daysLeft: `only {daysLeft} days left!`,
      hoursLeft: 'only a few hours left!',
    },

    showcase: {
      showMore: 'Show more',
      showLess: 'Show less',
    },

    gallery: {
      shareModal: {
        shareEventTitle: 'Share this event',
        shareGiftcardTitle: 'Share this gift card',
        copyLinkButton: 'Copy link',
        copiedLinkButton: 'Copied to clipboard',
        shareEventMessage: "Here's an event I found on konfetti",
        shareEventSubject: 'Check out this event',
        shareGiftcardMessage: "Here's a gift card I found on konfetti",
        shareGiftcardSubject: 'Check out this gift card',
      },
    },

    dateRequest: {
      sidebarTitle: 'Propose a date',
      sidebarSuccessTitle: 'Enquire now without obligation!',

      eventSuggestions: {
        title: 'Here are some classes you might like',
        requestSent: 'Your request has been sent',
        seeMoreButton: 'See more similar events',
        seeMoreNotification:
          'Here are some tailored classes based on your previous activity',
        cantBeHeldAtCustomLocation:
          'Bitte beachte, dass bei kleinen Gruppen das Event in der Location des Veranstalters stattfindet.',
      },

      generalSuccessMessage: 'Your request was sent, we will contact you soon.',
      generalSuccessShareEventButton: 'Share this event',
    },

    status: {
      soldOut: 'Sold Out',
      open: 'Available',
      expired: 'Expired',
      fewTicketsLeft: 'Few tickets left',
    },

    reviews: {
      reviewAmountLabel: 'New | {n} review | {n} reviews',
      ratingLabel: 'New | {n} | {n} ',
      newEventLabel: 'New',
      supplierVerifiedLabel: 'Verified partner',
      readMoreLabel: 'read more',
      reviewSectionSubtitle: 'New | Based on {n} review | Based on {n} reviews',
    },
    show: {
      calendarNoDates: {
        title: 'No future dates available currently',
        description: {
          waitlist:
            'No further dates available. Join the waitlist for future updates.',
          waitlistAndDateRequest:
            'No further dates available. Join the waitlist or request a specific date.',
          dateRequest:
            'No further dates available. Request a date for a specific date.',
          general:
            'No further dates available. Try requesting a private event or contacting us by chat.',
        },
      },

      datePickerCaptions: {
        publicDateLabel: 'Public',
        privateDateLabel: 'Private groups',
        soldOutLabel: 'Sold out',
      },

      timeSlots: {
        privateBadgeText: 'Private',
        sellingOutBadgeText: 'Selling out',
      },

      noAvailableDatesBox: {
        title: 'More dates coming soon',
        altTitle: 'Get notified for new dates',
        ctaTextOnlyProposeDate: 'Propose a date',
        ctaTextOnlyWaitlist: 'Waitlist',
        tooltipText:
          'Propose dates to the host or put your email on the waitlist and get notified.',
      },

      infoBanner: {
        private: "You're booking as an exclusive group",
        public: "You're booking a public class",
        box: 'The kit will be shipped to your home',
        multidate: "You're booking a multi-day course",
        atYourLocation: 'At your location',
        privateToggleLabel: 'Book as private event {privateEventExtraPrice}',
        duration: 'Duration:',
        people: {
          notProvided: 'No information',
          minOnly: 'from {n} people',
          maxOnly: 'up to {n} people',
          same: 'for {n} people',
          range: '{min} - {max} people',
        },
      },

      icons: {
        duration: 'Duration',
        whatsIncluded: "What's included",
        teamEventsAndGiftCards: 'Team events and private groups',
        locationSummary: 'Location',
        languages: {
          title: 'Languages',
          list: {
            de_DE: 'German',
            en_US: 'English',
            pt_BR: 'Portuguese',
            es_ES: 'Spanish',
            ja_JP: 'Japanese',
            fr_FR: 'French',
          },
        },
        mobileEvent: {
          title: 'Desired location',
          content: 'Also at your location',
        },
      },

      giftcardIcons: {
        duration: 'Duration',
        durationContent: 'Flexible choice of dates around the year',
        whatsIncluded: 'The perfect gift for',
        whatsIncludedContent: 'Gift card for a cooking class of your choice',
        teamEventsAndGiftCards: 'Gift card is redeemable for',
        teamEventsAndGiftCardsContent: 'Also valid for private events',
        locationSummary: 'Locations',
        locationContent: 'You will find our location on the map below',
        multipleLocationsSummary:
          'You will receive details about the location from the organizer after booking',
        languages: {
          title: 'Languages',
          content: 'German, English',
        },
      },

      privateEventInfo: {
        title: 'How does a private event work?',
      },

      basicDetails: {
        description: 'Class description',
        giftcardDescription: 'What you should know about the gift card',
        detailsToRemember: 'Details to remember',
        whatToBring: 'What to bring to the tour?',
        giftcardWhatToBring: 'What the gift card is redeemable for',
        whatIsIncluded: 'What is included in this tour?',
        giftcardWhatIsIncluded: 'How you will receive the gift card',
        courseProgress: 'Steps of the tour',
        courseTarget: 'Who should take part in this tour?',
      },

      boxDetails: {
        description: 'About the kit',
        courseProgress: 'This experience is inside the kit',
        courseTarget: 'Who is this kit suitable for?',
        detailsToRemember: 'Details on the kit',
        whatToBring: 'What you need to have on hand',
        whatIsIncluded: 'What is included in the kit',
        summaryWhatIsIncluded: 'What’s included',
        summaryMoreDetails: 'More details',
        buyBoxQuantity: 'Buy a kit',
        buyBoxQuantityHelperText: 'Please select the amount',
      },

      map: {
        title: 'Tour itinerary',
        showMore: 'See full itinerary',
        address: 'Address',
      },

      checkout: {
        quantity: 'Number of tickets',
        onlyNTicketsLeft: 'Only {n} Tickets left',
        time: 'Time',
        privateQuantity: 'Number of participants',
        privateQuantityPlaceholder: 'Select',
        triedToAddBeyondMaxTickets:
          'availability: Request event or check different dates',
        triedToAddBelowMinTickets:
          'Smaller groups pay the {minQty} people price',
        tryDateRequestButtonText: 'Request event',
        privateQuantityNoTicketsSelected:
          'Please select the number of participants',
        book: 'Add to cart',
        bookGiftcard: 'Buy gift card',
        selectDate: 'Select the date',
        availableTimes: 'Available times',
        noMoreDatesAvailable: 'No more dates available',
        giftcard: {
          sectionTitle: 'Buy gift card for',
          discountLabel: 'Previous price',
          infoBannerText: 'New dates coming soon!',
          giftExperiences: 'Recipient selects a workshop',
          forAnyKonfetti: 'Redeemable for over {eventCount} classes ',
          validity: 'Valid for three years',
        },
        embeddedGiftcard: {
          iconsLabels: {
            first: 'Valid for three years',
            second: 'Recipient selects workshop and date',
            third: 'Fun guaranteed :)',
          },
        },

        teamEvent: {
          title: 'Request a private event',
          boxTitle: 'Request this kit',
          titleWithPrice: 'Teamevent from {price} per Person',
          description:
            'Request specific dates for this event. Also for company events and private groups. Get a non-binding quote.',
          boxDescription:
            'Request several kits for your event. Also for company events and private groups. Get a non-binding quote.',
          contactUs: 'Send a request',
        },

        info: {
          publicEvent: 'Book one or more tickets for a public class.',
          privateEvent:
            'Book the course for a private group and enter the number of participants. The price per group starts at {price}.',
          giftcard:
            'The gift card can be redeemed for all classes and is valid for 3 years.',
        },

        shipping: {
          excludingShipping: 'excl. shipping',
          productCardInfo: 'plus shipping costs',
        },
        buyBoxPrivateQuantityHelperText: 'Each ticket is valid for one person',
        buyBoxPrivateBadge: 'Private',
        pricePrivateSubtitle: '{price} per ticket',
      },
    },

    card: {
      duration: 'Duration',
      durationDefaultContent: '1-5 hours',
      mobileClasses: 'At yours',
      productBox: 'Box',
      sale: 'Sale',
      price: {
        teamevent: `from {price} p.P.`,
      },
    },

    teamEventsForm: {
      title: 'Submit your request for a private event',
      noscript:
        "If you don't see a form, it is blocked by your browser or adblocker settings. Use another browser or write us at hallo{'@'}gokonfetti.com",
    },

    preview: {
      alert: {
        title: 'This is a preview',
        content: "This event is only a preview and isn't indexed",
      },
    },

    subscribeToEventUpdatesModal: {
      requestDateButtonLabel: 'Request a specific date',
      firstStep: {
        title: 'No fitting date?',
        description: 'Enter the waitlist or suggest specific dates below.',
        waitlistSectionTitle: 'Join the waitlist',
        waitlistSectionTitleTooltip:
          'Enter your email and we will notify you when new event dates are added.',
        dateRequestTitle: 'Propose specific dates',
        submitButtonLabel: 'Get notified',
        finishedButton: 'Continue browsing',
        requestDatesSectionSubtitle: 'Suggest up to three dates',
        requestDatesDescription: 'The more suggestions the better.',
        requestDatesButtonLabel: 'Submit your request',
        requestDatesDoneButtonLabel: 'Request sent',
        requestDateFormat: 'MM/DD/YYYY HH:mm',
        form: {
          email: {
            label: 'Email',
            placeholder: "johndoe{'@'}example.com",
          },
          phone: {
            label: 'Phone',
            placeholder: '+49 123 456 789',
            helperText:
              'Experience has shown that the quickest way to arrange your event is by telephone!',
          },
          notifySimilar: {
            label:
              'Notify me about all similar events from this or other Partners',
          },
          name: {
            label: 'Name',
            placeholder: 'John',
          },
          surname: {
            label: 'Surname',
            placeholder: 'Doe',
          },
          companyName: {
            label: 'Company name',
            helperText: "Of course, only if it's a company inquiry.",
          },
          numberOfTickets: {
            label: 'Number of tickets',
            placeholder: 'How many people?',
            privateEventError:
              'To request you need to be a group of minimum {privateEventMinTickets}.',
            dateRequestError:
              'To request you need to be a group of minimum {minTicketsDateRequest}.',
            errorText:
              'Please request a date on any Class page of your liking instead.',
            helperText:
              'Please select a higher number of people to send a private request or press the button underneath to browse similar events.',
          },
          dateType: {
            label:
              'Request a private event, suitable for bigger groups of people',
            toolTipText: 'This event can only be requested as private group',
          },
          date1: {
            label: 'Date 1',
            helperText:
              'If you have several possible dates, simply state the one you prefer.',
          },
          date2: {
            label: 'Date 2',
          },
          date3: {
            label: 'Date 3',
          },
          confirmContactCheckbox: {
            label: 'By clicking on “Send”, you agree that we will contact you.',
          },
        },
      },
      secondStep: {
        title: 'Successfully joined the waitlist',
        description: '',
        submitButtonLabel: 'Close window',
        iconBlockText:
          'Once new dates go live for this event, we will notify you.',
        requestDatesSuccessMessage:
          'Your dates request has been submitted successfully.',
      },
    },

    addOn: {
      detailsTitle: 'Add more to your class',
      detailsSubtitle: 'Here are some products you can add to your event',
      detailsCTA: 'Select a date to add to cart',
      addOnLabel: 'Add-on',
      addOnPlaceholder: 'Select add-on',
    },

    ticketCardsSection: {
      title: 'Available dates',
      perGroup: 'Per group',
      perPerson: ' each',
      addToCart: 'Add to cart',
    },

    eventLocation: {
      userLocation: 'At my location',
      partnerLocation: "At the organizer's location ({eventLocation})",
    },

    titleByCategory: {
      tour: {
        about: 'About this Tour',
        location: 'Address: The tour starts here',
      },
      kit: {
        about: 'About this kit',
        progress: 'What awaits you inside this kit?',
        courseTarget: 'Who should buy the kit?',
        whatToBring: 'What you need at hand',
        whatIsIncluded: 'What is inside the kit?',
      },
      course: {
        about: 'About this class',
        progress: 'What you’ll do in the class',
        courseTarget: 'Who is the class suitable for?',
        whatToBring: 'What to bring to the class',
        whatIsIncluded: 'What is included in the class?',
        location: 'Address - this is where the class takes place: ',
        teamEventAndPrivate: 'Teamevents and groups',
      },
      experience: {
        about: 'About this experience',
        progress: 'How does this experience take place?',
        courseTarget: 'Who is it suitable for',
        whatToBring: 'What to bring?',
        whatIsIncluded: 'What is included?',
        teamEventAndPrivate: 'Teamevents and groups',
        location: 'Address - this is where the experience takes place:',
      },
    },

    itemVariety: {
      GROUP_EVENT: 'Group event',
      TEAM_EVENT: 'Team event',
    },
  },
}
